export default __webpack_public_path__ + "static/media/n.32739c7e.jpg";